import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { toast, Toaster } from 'sonner';
import { App } from './App';
import { ErrorBoundary } from './components/ui/error-boundary';
import { ApiError } from './lib/api';
import { ThemeProvider, useTheme } from './design-system/theme';
import { AuthProvider } from './lib/auth';
// Bắt sự kiện cài ứng dụng (beforeinstallprompt) sớm, trước khi trang nào cần (X-PWA)
import { registerServiceWorker } from './lib/pwa';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
  },
});

/** Thông báo nổi theo theme Sáng/Tối. */
function AppToaster() {
  const { resolved } = useTheme();
  return <Toaster theme={resolved} position="top-right" richColors closeButton duration={3500} />;
}

// X-PWA bước 2: vỏ app chạy khi mất mạng; có bản mới thì hỏi trước khi tải lại
registerServiceWorker((apply) =>
  toast.info('Có bản ERP mới', {
    description: 'Lưu việc đang làm rồi bấm Tải lại.',
    duration: Infinity,
    action: { label: 'Tải lại', onClick: apply },
  }),
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary title="Ứng dụng gặp lỗi khi hiển thị">
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <App />
              <AppToaster />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
